import { useStore } from '@stores';
import { useEffect } from 'react';

export const useVehicleByVin = (vin?: string | null) => {
  const { vehicleStore } = useStore();
  const { vehicle } = vehicleStore;

  useEffect(() => {
    if (vin) {
      vehicleStore.getByVin(vin);
    }
  }, [vehicleStore, vin]);

  return vehicle;
};
